module.exports = __webpack_public_path__ + "static/img/brand-first-1.d36ed148.png";